import React from "react";
import { Box, MainText, PressableOpacity } from "app/components/common";
import EmptyPicture from "app/components/common/EmptyPicture";
import i18n from "@microdoing/shared/i18n";
import { StyleSheet, View } from "react-native";
import FastImage from "react-native-fast-image";
import { widthPercentageToDP } from "react-native-responsive-screen";
import { useDispatch, useSelector } from "react-redux";
import {
  getCoachId,
  getCoachName,
  getCoachPicture,
} from "@microdoing/shared/services/coaching/selectors";
import { openConversationRequest } from "@microdoing/shared/services/message/actions";
import MessageIcon from "./MessageIcon";
import theme from "app/Theme/Theme";
import { requestExternalUser } from "@microdoing/shared/services/externalProfile/actions";

const PICTURE_SIZE = 40;

const styles = StyleSheet.create({
  main: {
    marginTop: theme.spacing.m,
    width: widthPercentageToDP("90%"),
    alignSelf: "center",
    marginBottom: 25,
    flexDirection: "row",
  },
  picture: {
    height: PICTURE_SIZE,
    width: PICTURE_SIZE,
    borderRadius: PICTURE_SIZE / 2,
  },
  coachName: {
    flex: 1,
    flexWrap: "wrap",
    marginTop: 2,
    fontSize: 14,
    color: theme.colors["neutral.900"],
  },
  smallRoundButton: {
    height: 30,
    paddingVertical: 3,
    borderRadius: 25,
    backgroundColor: theme.colors["brand.500"],
    flexDirection: "row",
    paddingHorizontal: theme.spacing.s,
    justifyContent: "center",
    alignItems: "center",
  },
  icon: {
    marginRight: 8,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    alignSelf: "center",
  },
});

const CoachingHeader = () => {
  const dispatch = useDispatch();

  const coachId = useSelector(getCoachId);
  const coachName = useSelector(getCoachName);
  const coachPicture = useSelector(getCoachPicture);

  const onChatOpen = () => {
    if (coachId) {
      dispatch(
        openConversationRequest({
          receivers: [
            {
              _id: coachId,
              name: coachName,
              picture: coachPicture,
            },
          ],
        }),
      );
    }
  };

  const handlePressProfile = () => {
    if (coachId) {
      dispatch(requestExternalUser({ userId: coachId }));
    }
  };

  return (
    <Box
      marginTop="sm"
      width="90%"
      alignSelf="center"
      marginBottom="sm"
      flexDirection="row"
    >
      <Box
        overflow="hidden"
        alignItems="center"
        justifyContent="flex-start"
        flexDirection="row"
        flex={1}
      >
        <PressableOpacity onPress={handlePressProfile}>
          {!!coachPicture ? (
            <FastImage
              source={{ uri: coachPicture }}
              style={[styles.picture]}
            />
          ) : (
            <View style={styles.picture}>
              <EmptyPicture
                size={PICTURE_SIZE}
                firstName={coachName}
                variant="l8-bold"
              />
            </View>
          )}
        </PressableOpacity>
        <Box
          marginLeft="s"
          alignItems="flex-start"
          justifyContent="space-around"
          flexDirection="column"
        >
          <MainText color="neutral.500" variant="l2-regular">
            {i18n.t("my-coach")}
          </MainText>
          <MainText
            variant="l2-regular"
            paddingTop="null"
            color="neutral.900"
            ellipsizeMode="tail"
          >
            {coachName}
          </MainText>
        </Box>
      </Box>
      <Box
        marginLeft="m"
        alignItems="center"
        justifyContent="center"
        flexDirection="column"
        maxWidth={150}
      >
        <PressableOpacity style={styles.smallRoundButton} onPress={onChatOpen}>
          <MessageIcon style={styles.icon} height={12} width={14} />
          <MainText color="neutral.white" variant="l2-semibold">
            {i18n.t("contact")}
          </MainText>
        </PressableOpacity>
      </Box>
    </Box>
  );
};

export default CoachingHeader;
